// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const sectionInBodyMax = 20000;

export const sectionInPositionOneMin = 0;
export const sectionInPositionOneMax = 10000;

export const sectionInTitleOneMax = 200;

export const SectionIn = zod.object({
  "audience": zod.union([zod.enum(['internal', 'shareable']),zod.null()]).optional(),
  "body": zod.string().max(sectionInBodyMax),
  "position": zod.union([zod.int().min(sectionInPositionOneMin).max(sectionInPositionOneMax),zod.null()]).optional(),
  "revision": zod.int().min(1),
  "title": zod.union([zod.string().max(sectionInTitleOneMax),zod.null()]).optional()
});

export type SectionIn = zod.input<typeof SectionIn>;
export type SectionInOutput = zod.output<typeof SectionIn>;
